import { useSupabaseLoader } from "../../../../../server/supabase/hooks";
import { SupabaseSegmentService } from "../../../server/supabase-segment-service";

import type { UseSupabaseLoaderState } from "../../../../../server/supabase/hooks/types";
import type { ChannelName } from "../../../../channels/types";
import type { ToTarget } from "../../../../to/to-target";
import type { PersonInUnsavedSegmentWithChannels } from "../../../server/supabase-segment-service";
import type { Segment } from "../../../types";

export function useSegmentRecipients(
  segment_json: Segment["segment_json"],
  filterChannel?: ChannelName,
  target_connection_type?: ToTarget["target_connection_type"],
): UseSupabaseLoaderState<PersonInUnsavedSegmentWithChannels[]> {
  return useSupabaseLoader(
    async ({ supabase, account_id }) => {
      const { data, error } = await new SupabaseSegmentService(supabase).getAllUnsavedRecipients(
        account_id,
        segment_json,
        target_connection_type ?? undefined,
      );

      if (error) throw new Error(error.message);
      return data
        .map((x) => ({
          ...x,
          // oxlint-disable-next-line typescript/no-unsafe-type-assertion
          channels: x.channels as PersonInUnsavedSegmentWithChannels["channels"],
        }))
        .filter((x) => (filterChannel ? x.channels[filterChannel] : true));
    },
    [segment_json, filterChannel, target_connection_type],
  );
}
